import React from "react";

import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { FileAttribute } from "components/dashboard/product-template-table/utils/interfaces";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { T } from "services/lang/LanguageService";
import { FileType } from "utils/enums";

type FileCellProps = {
  attribute: FileAttribute;
  onAttributeChange: React.Dispatch<React.SetStateAction<FileAttribute>>;
};

const FileCell: React.FC<FileCellProps> = ({ attribute, onAttributeChange }) => {
  const types = Object.values(FileType);
  return (
    <div className="flex flex-wrap col-12 gap-3">
      <InputLabelWrapper labelName={T("word.type")} col={3}>
        <Dropdown
          value={attribute.fileType}
          options={types}
          onChange={e => onAttributeChange(prev => ({ ...prev, fileType: e.value, showThumbnail: false }))}
          placeholder={T("word.select-one")}
          invalid={!attribute.fileType}
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName={T("word.dialog-width")} col={3}>
        <InputNumber
          value={attribute.layoutConfig?.width}
          placeholder="50rem"
          suffix="rem"
          onChange={e =>
            onAttributeChange(prev => ({ ...prev, layoutConfig: { ...prev.layoutConfig, width: e.value } }))
          }
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName={T("word.dialog-height")} col={3}>
        <InputNumber
          value={attribute.layoutConfig?.height}
          suffix="vh"
          placeholder="70vh"
          onChange={e =>
            onAttributeChange(prev => ({ ...prev, layoutConfig: { ...prev.layoutConfig, height: e.value } }))
          }
        />
      </InputLabelWrapper>
      {attribute.fileType === FileType.IMAGE && (
        <InputLabelWrapper labelName={T("word.show-thumbnail")} col={2} className="mb-1">
          <InputSwitch
            checked={attribute.showThumbnail}
            onChange={e => onAttributeChange(prev => ({ ...prev, showThumbnail: e.value }))}
          />
        </InputLabelWrapper>
      )}
    </div>
  );
};

export default FileCell;
